// import { useEffect } from "react";

// export default function useAutoLogout() {
//   useEffect(() => {
//     let timer;

//     const logout = () => {
//       localStorage.removeItem("authToken");
//     //   alert("Session expired due to inactivity");
//       window.location.href = "/login";
//     };

//     const resetTimer = () => {
//       clearTimeout(timer);
//       timer = setTimeout(logout, 5 * 60 * 1000); // 5 minutes
//     };

//     window.addEventListener("mousemove", resetTimer);
//     window.addEventListener("keydown", resetTimer);
//     window.addEventListener("click", resetTimer);
//     window.addEventListener("scroll", resetTimer);

//     resetTimer();

//     return () => {
//       window.removeEventListener("mousemove", resetTimer);
//       window.removeEventListener("keydown", resetTimer);
//       window.removeEventListener("click", resetTimer);
//       window.removeEventListener("scroll", resetTimer);
//     };
//   }, []);
// }

import React, { createContext, useContext, useEffect, useCallback, useRef, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const inactivityTimer = useRef(null);

  // --- 1. SYNCHRONOUS CHECK ---
  // This function runs IMMEDIATELY when the component is created.
  const [authState] = useState(() => {
    const token = localStorage.getItem("authToken");
    const isSessionActive = sessionStorage.getItem("isLoggedIn");

    // If we have a token but NO session flag, it's a fresh tab open (not a refresh).
    if (token && !isSessionActive) {
      localStorage.removeItem("authToken");
      return { authenticated: false };
    }

    return { authenticated: !!token };
  });

  const logout = useCallback((shouldRedirect = true) => {
    localStorage.removeItem("authToken");
    sessionStorage.removeItem("isLoggedIn");
    if (shouldRedirect) {
      window.location.replace("/login");
    }
  }, []);

  useEffect(() => {
    // If the sync check above found we aren't authenticated, kick to login.
    if (!authState.authenticated) {
      if (window.location.pathname !== "/login") {
        logout();
      }
      return;
    }

    // --- 2. MARK SESSION AS ACTIVE ---
    // This ensures the NEXT refresh sees "isLoggedIn" as true.
    sessionStorage.setItem("isLoggedIn", "true");

    // --- 3. INACTIVITY TIMER ---
    const resetTimer = () => {
      if (inactivityTimer.current) clearTimeout(inactivityTimer.current);
      inactivityTimer.current = setTimeout(() => logout(), 10 * 60 * 1000);
    };

    const activityEvents = ["mousemove", "keydown", "click", "scroll"];
    activityEvents.forEach((ev) => window.addEventListener(ev, resetTimer));
    resetTimer();

    // --- 4. CROSS-TAB LOGOUT SYNC ---
    const handleStorageChange = (e) => {
      if (e.key === "authToken" && e.newValue === null) logout();
    };
    window.addEventListener("storage", handleStorageChange);

    return () => {
      if (inactivityTimer.current) clearTimeout(inactivityTimer.current);
      activityEvents.forEach((ev) => window.removeEventListener(ev, resetTimer));
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [logout, authState.authenticated]);

  return (
    <AuthContext.Provider value={{ logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);